import { z } from 'zod';

export const PasswordSchema = z
	.string()
	.trim()
	.min(8, 'Password must be at least 8 characters long')
	.max(64, 'Password must be less than 64 characters long')
	.regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
	.regex(/[a-z]/, 'Password must contain at least one lowercase letter')
	.regex(/[0-9]/, 'Password must contain at least one number')
	.regex(/[^A-Za-z0-9]/, 'Password must contain at least one special character');

export const ResetPasswordFormSchema = z.object({
	confirmPassword: z.string().trim().min(1, 'Please confirm your password'),
	password:        PasswordSchema,
	oobCode:         z.preprocess(
		val => (val === 'string' ? val.trim() : ''),
		z.string().trim().min(1, 'Invalid or missing password reset code.  Try requesting a new password reset.'),
	),
}).refine(check => check.password === check.confirmPassword, {
	message: 'Passwords do not match',
	path:    [ 'confirmPassword' ],
});
export type ResetPasswordFormModel = z.infer<typeof ResetPasswordFormSchema>;
